import { createActions, createReducer } from 'reduxsauce'

import ModalidadeService from '_/servicos/ModalidadeService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaModalidadeInicio: [],
    buscaModalidadeSucesso: ['modalidade'],
    buscaModalidadeErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaModalidade = () => {
    return dispatch => {
        dispatch(Creators.buscaModalidadeInicio())
        let serv = new ModalidadeService()
        return serv
            .getModalidade()
            .then(response => dispatch(Creators.buscaModalidadeSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaModalidadeErro(error)))
    }
}

const buscaModalidadeInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaModalidadeErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaModalidadeSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.modalidade, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_MODALIDADE_INICIO]: buscaModalidadeInicio,
    [Types.BUSCA_MODALIDADE_ERRO]: buscaModalidadeErro,
    [Types.BUSCA_MODALIDADE_SUCESSO]: buscaModalidadeSucesso,
})
